var STOREFRONT_TOKEN = 'f65c70b9b1eee7a0c430b9964e885b54';
var SHOP_DOMAIN = 'catherine-best-dev.myshopify.com';

async function getAllVariants() {
  var handle = window.location.pathname.split('/products/')[1];
  if (!handle) return;
  handle = handle.split('?')[0];

  var allVariants = [];
  var cursor = null;
  var hasMore = true;

  while (hasMore) {
    var afterPart = cursor ? `, after: "${cursor}"` : '';
    var query = `{
      product(handle: "${handle}") {
        variants(first: 250${afterPart}) {
          pageInfo { hasNextPage endCursor }
          edges {
            node {
              id
              title
              availableForSale
              price { amount }
              selectedOptions { name value }
            }
          }
        }
      }
    }`;

    var res = await fetch(
      'https://' + SHOP_DOMAIN + '/api/2024-04/graphql.json',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
        },
        body: JSON.stringify({ query: query })
      }
    );

    var data = await res.json();
    var variants = data.data.product.variants;

    variants.edges.forEach(function(edge) {
      allVariants.push(edge.node);
    });

    hasMore = variants.pageInfo.hasNextPage;
    cursor = variants.pageInfo.endCursor;
  }

  window.allVariants = allVariants;
  console.log('✅ Total variants loaded:', allVariants.length);
}

getAllVariants();